import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { arrayToObjectByField } from "Utils";
import { OnlineStatusesData } from "Utils/webSocketUtils";

interface VehiclesStateData {
  data: VehiclesStateDataItem | null;
}

const initialState: VehiclesStateData = {
  data: null,
};

export const Slice = createSlice({
  name: "vehiclesState",
  initialState,
  reducers: {
    resetVehicleStateData: () => initialState,
    updateVehiclesStateData: (state, action) => {
      state.data = action.payload;
      return state;
    },
    setVehiclesStateData: (state, action) => {
      state.data = arrayToObjectByField(action.payload, "vehicle_id");
      return state;
    },
    updateVehicleOnlineStatuses: (
      state,
      action: PayloadAction<OnlineStatusesData>
    ) => {
      const incoming = action.payload;
      const incomingIds = Object.keys(incoming);
      if (!state.data) {
        return state;
      }
      for (const vehicleId of incomingIds) {
        if (state.data[vehicleId]) {
          // Merge per-field: the full periodic poll carries all status fields,
          // but an edge-triggered flip sends only the changed field(s). Spreading
          // the incoming entry overwrites just what it provides and preserves the
          // rest (e.g. last_contact on a bare OFFLINE delta), instead of nulling
          // fields the delta omitted.
          state.data[vehicleId] = {
            ...state.data[vehicleId],
            ...incoming[vehicleId],
          };
        }
      }
      return state;
    },
  },
});

export default Slice;
